<template>
    <div>
        <b-sidebar ref="sidebar" id="sidebar-right" title="Selected" right shadow>
            <div class="px-3 py-2">
                <simple-list-group :data-list="selectRows"
                                   enable-cancel
                                   label-name="id"
                                   @rowCancel="removeRow"></simple-list-group>
            </div>
            <template #footer>
                <b-button block
                          variant="warning"
                          class="m-2"
                          :active="selectRows.length>0"
                          @click="needTableView">
                    <i class="fa-solid fa-eye"></i>
                    查看已选择
                </b-button>
            </template>
        </b-sidebar>
        <b-avatar v-show="selectRows.length!==0"
                  :badge="selectRows.length+''"
                  badge-variant="danger"
                  badge-top
                  size="lg"
                  class="avatar-float"
                  button
                  v-b-toggle.sidebar-right
                  icon="list-check"
                  variant="light">
        </b-avatar>
    </div>
</template>

<script>
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import SimpleListGroup from "@/components/echarts-part/CalendarShift/cells/stuffs/SimpleListGroup";

export default {
    name: "OverSelect",
    components: {SimpleListGroup},
    mixins: [emCommonUtilMixin],
    data() {
        return {
            selectRows: []
        }
    },
    methods: {
        addRows(rows) {
            if (rows.length > 0) {
                for (let row of rows) {
                    if (row.id && !this.selectRows.some(o => o.id === row.id)) {
                        this.selectRows.push(row);
                    }
                }
            }
        },
        checkedIds() {
            let tempList = [];
            for (let item of this.selectRows) {
                tempList.push(item.id);
            }
            return tempList;
        },
        checkedRows() {
            return this.selectRows;
        },
        needTableView() {
            this.$emit('needTableView');
        },
        removeRow(row) {
            for (let i = 0; i < this.selectRows.length; i++) {
                if (this.selectRows[i].id === row.id) {
                    this.selectRows.splice(i, 1);
                    break;
                }
            }
            if (this.selectRows.length === 0) {
                this.$refs.sidebar.hide();
            }
        },
    }
}
</script>

<style scoped>
.avatar-float {
    position: fixed;
    right: 2rem;
    bottom: 1rem;
    z-index: 10000;
}

.btn-size {
    font-size: 20px !important;
}
</style>